import {combineReducers} from 'redux';
import { CompanyReducers } from './CompanyReducers';



export const Reducers=combineReducers({
    CompanyReducers    
});


